import React from 'react';
import { useAppUserAccountCreate } from '../../../types/generated';
import { useNavigate } from 'react-router-dom';
import { UserEditFormView } from '../UserEditForm/view';

export const UserCreateForm = (): JSX.Element => {
    const navigate = useNavigate();

    const [userCreate, { loading }] = useAppUserAccountCreate({
        onCompleted() {
            navigate('/extranet/team');
        },
    });

    const onSubmit = (values, form, callback) => {
        userCreate({ variables: values })
            .then(() => callback())
            .catch(err => callback(err));
    };

    const onCancel = () => {
        navigate('/extranet/team');
    };

    return (
        <UserEditFormView loading={loading} onSubmit={onSubmit} user={null} onCancel={onCancel} />
    );
};
